var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { listWaitListEmails as listWaitListEmailQuery, getWaitListEmail as getWaitListEmailQuery } from '../../graphql/queries';
import { callGraphQL } from '../common/common';
/**
 * Gets a wait list email
 * Requires Cognito Groups: [Employee, Service]
 * @param email Email of the user requesting to be on the wait list
 */
export function getWaitListEmailRecord(email) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield callGraphQL(getWaitListEmailQuery, { id: email });
        return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.getWaitListEmail;
    });
}
/**
 * Lists all wait list emails
 * Requires Cognito Groups: [Employee, Service]
 * @param optParams
 */
export function listWaitListEmail(optParams) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const params = Object.assign({}, optParams);
        const res = yield callGraphQL(listWaitListEmailQuery, params);
        const { items, nextToken } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.listWaitListEmails;
        return { items, nextToken };
    });
}
